<template>
  <div class="subheader_container">
    <div
      id="highlight-title"
      class="subheader__content width-responsiveness"
    >
      <div
        id="tutorial-highlight-subheader"
        class="subheader__title"
      >
        <button
          v-if="backBtn"
          class="btn mr-4"
          @click="handleBackBtnClick"
        >
          <md-icon md-src="/static/images/icon-return-arrow.svg" />
        </button>
        <md-card-header-text>
          <div class="flex flex-row align-end gap-2">
            <md-icon
              v-if="iconPath"
              :md-src="iconPath"
            />
            <h2>
              {{ title }}
            </h2>
          </div>
          <span>
            <span>{{ timeAgo.phrase }}</span>
            <span class="text-bold">{{ timeAgo.time }}</span>
          </span>
        </md-card-header-text>
        <slot name="info" />
        <slot name="actions" />
        <slot name="filter-labels" />
        <slot name="search" />
      </div>
      <div class="subheader__content__right-side">
        <slot />
        <slot name="right-side" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { DASHBOARD_INTERVAL_TIME_STAMP_MILISECONDS } from '@/enums'
import moment from 'moment'
import { onMounted, ref, defineProps, onBeforeUnmount, computed } from 'vue'
import router from '@/router'

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  subtitle: {
    type: String,
    default: ''
  },
  backBtn: {
    type: Boolean,
    default: true
  },
  backRouterPath: {
    type: String,
    default: ''
  },
  backRouterName: {
    type: String,
    default: ''
  },
  iconPath: {
    type: String,
    default: ''
  },
  updatedTime: {
    type: Boolean,
    default: false
  }
})

const interval = ref(null)
const minutes = ref(0)
const updateTime = ref(new Date())

const timeAgo = computed(() => {
  if (minutes.value === 0) {
    return { phrase: 'atualizado', time: 'agora' }
  } else {
    return { phrase: 'atualizado há', time: `${minutes.value} min` }
  }
})

onMounted(() => {
  updateTimeAgo()
})

onBeforeUnmount(() => {
  clearInterval(interval.value)
})

const updateTimeAgo = () => {
  interval.value = setInterval(() => {
    calculateTimeAgo()
  }, DASHBOARD_INTERVAL_TIME_STAMP_MILISECONDS)
}

const calculateTimeAgo = () => {
  const now = new Date()
  const milliseconds = Math.abs(updateTime.value.getTime() - now.getTime())
  minutes.value = Math.floor(moment.duration(milliseconds).asMinutes())
}

const handleBackBtnClick = () => {
  const { backRouterPath, backRouterName } = props
  if (backRouterPath) {
    router.push({ path: backRouterPath })
  } else if (backRouterName) {
    router.push({ name: backRouterName })
  } else {
    router.go(-1)
  }
}
</script>

<style lang="scss" scoped>
@import '../../../static/stylesheets/variables';

  .subheader_container {
    height: $subHeaderHeight;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-shrink: 0;
    flex-grow: 0;
    position: absolute;
    background-color: #ebebeb;
    top: $mainHeaderHeight;
    z-index: 10;
    left: 0;

  .subheader {
    &__title {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &__content {
      display: flex;
      align-items: center;
      justify-content: space-between;

        h2 {
          font-size: 22px;
          line-height: 19px;
          font-weight: normal;
          letter-spacing: -0.3px;
          text-align: end;
          color: $label-color;
        }

      .filter-labels {
        color: #7f1a54;
        border-bottom: 3px solid #ddd;
        padding-bottom: 4px;
        text-transform: lowercase;
        cursor: pointer;
      }

      &__right-side {
        margin-left: -100px;
      }
    }
  }

  .subheader-actions-container {
    display: flex;

    &__turn-back {
      display: flex;
      padding-right: 25px;
      padding-left: 25px;

      .md-icon {
        padding: 2px;
        cursor: pointer;
      }
    }
  }

  .subheader-alternative-actions-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    top: 25px;
    position: relative;
    text-align: end;
    justify-content: flex-end;

    button {
      margin-right: 15px;
      margin-top: auto;
      margin-bottom: auto;

      .md-icon {
        padding: 4px;
      }
    }

    .position-right {
      display: flex;
      padding-right: 25px;

      .md-icon {
        margin: auto 0 auto auto;
        height: 1px;
      }
    }
  }

  .subheader-actions-search {
    position: relative;
    top: 40px;
    min-height: 44px;
    float: right;
  }

    .btn {
      background-color: transparent;

      svg {
        fill: #7f1a54;
      }
    }

  .text-bold {
    font-weight: bold;
  }
}
</style>